module.exports = __webpack_public_path__ + "static/media/stroopwafel.c5a0d532.svg";